export default "__VITE_ASSET__wyzYhixF__"